'use client';

import Link from 'next/link';

import { trackFreeToolCtaClick } from '@/components/free-tools/track-free-tool-cta';

/**
 * The signup-gate button under a cap-rejection error (2026-09-16 test: the
 * cap converts to a signup, not an upgrade).
 *
 * Renders only when the error text carries "Sign up free": the server writes
 * that phrase only into anonymous-tier cap messages (member messages never
 * have it), so the copy doubles as the signed-out signal without threading
 * auth state into the public /tools pages, which deliberately mount no
 * ClerkProvider.
 */
export function CapSignupCta({ error, slug }: { error: string | null; slug?: string }) {
  if (!error || !/sign up free/i.test(error)) return null;

  return (
    <Link
      href="/sign-up"
      onClick={() =>
        trackFreeToolCtaClick({
          surface: 'cap_gate',
          slug,
          destination: '/sign-up',
          label: 'Sign up free',
        })
      }
      className="mt-3 inline-flex items-center justify-center rounded-full bg-[rgb(var(--primary))] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[rgb(var(--primary-hover))]"
    >
      Sign up free
    </Link>
  );
}
